export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.45.0-30c130124.svg#cart-v2-large","viewBox":"0 0 26 26"}